export { default, ManagerTableCellCertificationStatus } from './ManagerTableCellCertificationStatus';